





























import Vue from "vue";
import { Component } from "vue-property-decorator";
import { card, user } from "../board";
import { Action, Mutation, State } from "vuex-class";
import Comment from "./Comment.vue";
const ESC_KEY_CODE = 27;

@Component({
  components: {
    Comment
  }
})
export default class CommentModal extends Vue {
  @Action createComment;
  @Mutation setCommentsModalIsActive;
  @State("myUser") storeMyUser: user;
  @State("selectedCard") card!: card;
  @State("commentsModalIsActive") isActive: boolean;
  private isNewCommentInputVisible = false;
  private newCommentContent = "";

  public toggleNewCommentInput() {
    this.isNewCommentInputVisible = !this.isNewCommentInputVisible;
    if (this.isNewCommentInputVisible) {
      this.$nextTick(() => {
        (this.$refs.contextCommentArea as HTMLElement).focus();
      });
    }
  }

  toggleModal() {
    this.setCommentsModalIsActive(!this.isActive);
  }

  addCommentToCard() {
    if (this.newCommentContent !== "") {
      const newComment = {
        newComment: {
          card: this.card._id,
          content: this.newCommentContent.trim(),
          createdOn: new Date()
        },
        board: this.card.board
      };
      this.createComment(newComment);
      this.newCommentContent = "";
    }
  }

  mounted() {
    window.addEventListener("keyup", e => {
      if (e.keyCode === ESC_KEY_CODE) {
        this.setCommentsModalIsActive(false);
      }
    });
  }
}
